import React, { useContext } from "react";
import ProgressBar from "../component/checkup/ProgressBar";
import CheckupArea from "./checkup-section/CheckupArea";
import Result from "./checkup-section/ResultPage";
import { MainContext } from "../utils/MainContext";

const CheckUpPage = () => {
  const { complete } = useContext(MainContext);
  return (
    <main>
      <section className="check-up">
        <div className="container">
          <ProgressBar />
          {!complete ? <CheckupArea /> : <Result />}
        </div>
      </section>
    </main>
  );
};

export default CheckUpPage;
